import * as Styled from './mainContainer.styles'
import { useTheme } from '@cellectenergy/cellect-react-components'
import MainLayout from '@/layouts/MainLayout'

export const MainBlog = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme()
  return (
    <MainLayout
      navbarTheme="light"
      title="Cellect Blog"
      description="Cellect Blog"
      url="www.cellectenergy.com"
      spacerDisplay="none"
      imgUrl="/assets/blog/bgImage.webp"
    >
      <Styled.MainContainer>{children}</Styled.MainContainer>
    </MainLayout>
  )
}
